import { render, staticRenderFns } from "./UserOptions.vue?vue&type=template&id=2d1a1b50&scoped=true&"
import script from "./UserOptions.vue?vue&type=script&lang=js&"
export * from "./UserOptions.vue?vue&type=script&lang=js&"
import style0 from "./UserOptions.vue?vue&type=style&index=0&id=2d1a1b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1a1b50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3001884671/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1a1b50')) {
      api.createRecord('2d1a1b50', component.options)
    } else {
      api.reload('2d1a1b50', component.options)
    }
    module.hot.accept("./UserOptions.vue?vue&type=template&id=2d1a1b50&scoped=true&", function () {
      api.rerender('2d1a1b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/containers/core/header/UserOptions.vue"
export default component.exports